export default __webpack_public_path__ + "images/ee79578476f41ae74ddf70e3be763b93-cartebancaire@2x.png";